const ApiErrorModalIds = {
  ConnectionError: 'ApiConf_ConnectionErrorModal',
  AccessDenied: 'ApiConf_AccessDeniedModal',
  LoggedOut: 'ApiConf_LoggedOutModal',
  ServerError: 'ApiConf_ServerErrorModal',
} as const;

export default ApiErrorModalIds;
